module.exports = __webpack_public_path__ + "img/5.b979e3ac.png";